import React from 'react';
import { Box, Stack } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import HelpImg from 'pages/provisioning/_components/helpImg';
import { isRuleNameValid, OrderPayload } from 'pages/user-preferences/store';

export const RuleName = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [helperText, setHelperText] = React.useState(false);
    const [, setRuleNameValid] = useRecoilState(isRuleNameValid);

    const setRuleName = (ruleName = '') => {
        setOrder({
            ...order,
            ruleName,
        });
    };

    React.useEffect(() => {
        const isValidFormat = /^[^\s]+(\s+[^\s]+)*$/.test(order?.ruleName) && order?.ruleName?.length <= 200;
        if (order?.ruleName && order?.ruleName !== null && order?.ruleName !== '' && order?.ruleName !== undefined && !isValidFormat) {
            setHelperText(true);
            setRuleNameValid(false);
        } else {
            setHelperText(false);
            setRuleNameValid(true);
        }
    }, [order?.ruleName]);

    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.ruleName) || helperText) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (!order?.ruleName && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.ruleName, order?.isTouched]);

    return (
        <>
            <Stack direction="column" spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <Box sx={{ paddingRight: '8px', fontWeight: 600 }}>RULE NAME</Box>
                    <HelpImg
                        title={
                            <Box sx={{ whiteSpace: 'pre' }}>
                                <Box>Any name to distinguish current rule from your other rules.</Box>
                                <Box>Name should not exceed more than 200 characters.</Box>
                            </Box>
                        }
                    />
                </Box>
                <Box>
                    <CssTextField
                        size="small"
                        sx={{
                            width: (theme) => theme.spacing('100%'),
                            '& .MuiFormHelperText-root': {
                                marginTop: (theme) => theme.spacing('-2'),
                            },
                        }}
                        autoComplete="off"
                        label="Enter Your Rule Name *"
                        error={helperText}
                        helperText={helperText && <span>Rule Name is Invalid.</span>}
                        value={order?.ruleName || ''}
                        onChange={(e) => setRuleName(e.target.value)}
                        className={validateInput()}
                        data-testid="rule-name-text"
                    />
                </Box>
            </Stack>
        </>
    );
};

export default React.memo(RuleName);
